import store from "../store/store.js";


export function all (to, from, next) {
  if (to.name === "login") {
    next();
  } else if (store.getters.hasAccess) {
    next();
  } else {
    store.
      dispatch("authenticate").
      then(() => {
        if (store.getters.hasAccess) {
          next();
        } else {
          next({ name: "login" });
        }
      });
  }
};

export function login (to, from, next) {
  store.
    dispatch("authenticate").
    then(() => {
      if (store.getters.hasAccess) {
        next(from.path);
      } else {
        next();
      }
    });
};



// WEBPACK FOOTER //
// ./src/router/guards.js